// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rejection-box[data-v-0f3b42f5]  .el-select{width:360px;height:32px;background:#fff;border-radius:4px 4px 4px 4px;opacity:1;margin-bottom:16px}.rejection-box[data-v-0f3b42f5]  .el-select .el-input__inner{height:32px;line-height:32px}.rejection-box[data-v-0f3b42f5]  .el-textarea{width:540px;height:222px;background:#fafafa;border-radius:4px 4px 4px 4px;opacity:1}.rejection-box[data-v-0f3b42f5]  .el-textarea .el-textarea__inner{height:222px}", ""]);
// Exports
module.exports = exports;
